import React, { Fragment, useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../core/Contexts/AppContext';
import { getPenaltyDetails } from '../../core/services/penalty';
import { NavLink } from 'react-router-dom';

const PenaltyDetail = () => {
  const params = useParams();
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);
  const [penalty, setPenalty] = useState();

  useEffect(() => {
    setTitle('საჯარიმო ქვითრები და დადგენილებები');
    setImage('../../images/main-hero.png');
    setHeaderType(1);
  }, []);

  useEffect(() => {
    void getPenaltyDetails(params.id).then((result) => {
      setPenalty(result);
    });
  }, [params.id]);

  if (!penalty) {
    return <div>No penalty details available</div>;
  }

  return (
    <>
      <div className='container'>
        <div className='penaltyDetail'>
          <div>
            საიდენტიფიკაციო ნომერი / პირადი ნომერი:
            <span className='color__blue ml-20'>
              {penalty.company_id_number}
            </span>
          </div>
          <span>
            სამართალდამრღვევის დასახელება / სახელი, გვარი:
            <span className='color__blue ml-20'>{penalty.company_name}</span>
          </span>
        </div>
        <div key={penalty.id} className='penalty_wrapper'>
          <div className='penaltyDate'>
            გამოქვეყნების თარიღი:
            <span className='color__blue ml-20'>
              {penalty.created_at.split(' ')[0]}
            </span>
          </div>
          <div className='penaltyFiles'>
            {penalty.doc && (
              <div className='tst'>
                <div className='penaltyIcon1'>
                  <a
                    className='color__blue penalty-download'
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`https://form.msa.gov.ge/uploads/${penalty.doc}`}
                  >
                    <img
                      className='d-icon'
                      src='../../images/downloadFile.png'
                      alt='download'
                    />
                  </a>
                </div>
                <div className='penaltyFile1'>
                  ადმინისტრაციული სამართალდარღვევის ოქმი:
                  <a
                    className='color__blue penalty-download'
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`https://form.msa.gov.ge/uploads/${penalty.doc}`}
                  >
                    № - {penalty.penalty_number}
                  </a>
                </div>
              </div>
            )}

            {penalty.resolution_doc && (
              <div className='tst'>
                <div className='penaltyIcon1'>
                  <a
                    className='color__blue penalty-download'
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`https://form.msa.gov.ge/uploads/${penalty.resolution_doc}`}
                  >
                    <img
                      className='d-icon'
                      src='../../images/downloadFile.png'
                      alt='download'
                    />
                  </a>
                </div>
                <div className='penaltyFile1'>
                  გამოცემული დადგენილება:
                  <a
                    className='color__blue penalty-download'
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`https://form.msa.gov.ge/uploads/${penalty.resolution_doc}`}
                  >
                    № - {penalty.legislation_number}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PenaltyDetail;
